import { constants } from "constants/constants";
import { RefObject, useEffect, useState } from "react";
import { getLocalStorage, setLocalStorage } from "services/local-storage";
import { DaySchedule } from "hooks/use-live-classes/use-live-classes.types";

const useClassScheduleTooltip = (
  classSchedule: DaySchedule[],
  classScheduleRef: RefObject<HTMLDivElement>
) => {
  const [isBirdTooltipVisible, setBirdTooltipVisible] = useState(false);
  const [isClassScheduleTooltipVisible, setClassScheduleTooltipEnabled] =
    useState(false);

  useEffect(() => {
    const tooltipShown =
      (getLocalStorage(
        constants.CLASS_SCHEDULE_TOOLTIP_VIEWED_KEY
      ) as boolean) === true;
    if (classSchedule && classSchedule.length > 0 && !tooltipShown) {
      setBirdTooltipVisible(true);
      setClassScheduleTooltipEnabled(false);
    }
  }, [classSchedule]);

  const handleBirdTooltipSkip = () => {
    setBirdTooltipVisible(false);
    setLocalStorage(constants.CLASS_SCHEDULE_TOOLTIP_VIEWED_KEY, true);
  };

  const handleBirdTooltipCheckNow = () => {
    setBirdTooltipVisible(false);
    setClassScheduleTooltipEnabled(true);

    if (classScheduleRef.current) {
      classScheduleRef.current.scrollIntoView({
        behavior: "smooth",
        block: "end"
      });
    }
  };

  const handleClassScheduleTooltipClick = () => {
    setClassScheduleTooltipEnabled(false);
    setLocalStorage(constants.CLASS_SCHEDULE_TOOLTIP_VIEWED_KEY, true);
  };

  return {
    isBirdTooltipVisible,
    isClassScheduleTooltipVisible,
    handleBirdTooltipSkip,
    handleBirdTooltipCheckNow,
    handleClassScheduleTooltipClick
  };
};

export default useClassScheduleTooltip;
